<template>
  <div class="content">
    <div v-if="loading" class="loading_div">
      <i class="el-icon-loading" style="font-size: 30px;color: #ffffff;margin-bottom: 20px;"></i>
      <!-- <div style="font-size: 14px;color: #ffffff;">Loading...</div> -->
    </div>
    <div v-if="loading_init" class="loading_div">
      <i class="el-icon-loading" style="font-size: 30px;color: #ffffff;margin-bottom: 20px;"></i>
      <div style="font-size: 14px;color: #ffffff;">Loading...</div>
    </div>
    <div class="item1" v-if="step == 1">
      <img :src="obj.company_logo"/>
      <div class="title">
        {{obj.company_name}}
      </div>
      <p>
        Hello, {{obj.client_name}}<br/>
        Your opinion helps us improve.</br>Would you recommend our services to others?
      </p>
      <div class="btnDiv">
        <div class="btn" @click="step = 2">No</div>
        <div class="btnAct" @click="step = 3">Yes</div>
      </div>
    </div>
    <div class="item2" v-if="step == 2">
      <div class="title">Please leave us feedback</div>
      <el-input type="textarea" class="textarea" placeholder="post workout recovery lab, sport therapy" v-model="feedback_text"></el-input>
      <div class="btnDiv">
        <div class="btnAct" @click="submit_feedback">Submit</div>
      </div>
    </div>
    <div class="item3" v-if="step == 3">
      <div class="title">We’d love to hear about your recent experience with us! </div>
      <p>
        Thank you for taking the time to share your thoughts — your feedback means a lot.It helps us enhance our service and deliver the best possible care and experience.
      </p>
      <h1>How was your overall experience? </h1>
      <div class="div">
        <p>
          Please take a moment to let us know your thoughts. Your feedback helps us enhance our quality of care and service. Select the words that best capture your experience.<br/>        </p>

        <div style="display: flex;align-items: center;justify-content: flex-start;font-size: 14px;font-weight: bold;">
          Select the words that describe your experience
        </div>
        <div class="lables">
          <span :class="item.is_select?'act':''" v-for="(item,index) in keywords" :key="index" @click="select_keyword(item)">{{item.title}}</span>
        </div>
        <el-input :autosize="{ minRows: 4}" type="textarea" placeholder="Please enter some comments" v-model="comment"></el-input>
      </div>
      <div style="display: flex;justify-content: flex-end;width: 100%;">
        <div class="btnAct" @click="generate_review">Generate</div>
      </div>

      <h1 @click="show_review_method" style="display: flex;align-items: center;justify-content: space-between;padding-right: 15px;">
        Review Suggestion
        <i class="el-icon-arrow-down" v-if="!show_review"></i>
        <i class="el-icon-arrow-up" v-if="show_review"></i>
      </h1>
      <div class="div" v-if="show_review">
        <el-input :autosize="{ minRows: 4}" type="textarea" placeholder="" v-model="ai_generate_text"></el-input>
        <div style="display: flex;justify-content: flex-end;align-items: center;width:100%;" v-if="ai_content.length > 0">{{now_number + 1}}/{{ai_content.length}}</div>
      </div>
      <div style="display: flex;justify-content: flex-end;width: 100%;" v-if="show_review">
        <div class="btn" @click="copyToClipboard">Copy</div>
        <div class="btnAct" @click="re_generate_review">Regenerate</div>
      </div>


      <h1 @click="show_url_method" style="display: flex;align-items: center;justify-content: space-between;padding-right: 15px;">
        Share Your Review
        <i class="el-icon-arrow-down" v-if="!show_url"></i>
        <i class="el-icon-arrow-up" v-if="show_url"></i>
      </h1>
      <div class="div" v-if="show_url">
        <div class="menuItem" @click="click_url(1, obj.google_url)">
          <img src="../assets/imgs/icons/icon_pro6.png"/>
          Review us on Google
        </div>

        <div class="menuItem" @click="click_url(2, obj.yelp_url)">
          <img src="../assets/imgs/icons/icon_pro5.png"/>
          Review us on Yelp
        </div>
      </div>
    </div>
    <div class="item3" v-if="step == 4">
      <el-result icon="success" title="Review success" subTitle="Thank you for participation">
        <template slot="extra">
        </template>
      </el-result>
    </div>
    <div class="item3" v-if="step == 5">
      <el-result icon="warning" title="This link has expired" subTitle="Review links work for 7 days. Please ask the business for a new link.">
        <template slot="extra">
        </template>
      </el-result>
    </div>
  </div>
</template>

<script>
  import { mapGetters,mapActions } from 'vuex'
  import { getActionApi,postActionApi,putActionApi } from '@/network/manageApi';
  import Vue from 'vue'


  export default {
    name: 'AIBusinessPromoterDetail',
    components: {
    },
    data() {
      return {
        loading: false,
        loading_init: false,
        key: '',
        pageIndex: 0,
        obj: {},
        step: 4,
        feedback_text: "",
        keywords: [],
        comment: "",
        ai_generate_text: "",
        show_review: false,
        show_url: false,
        ai_content: [],
        now_number: 0
      }
    },
    computed: {

    },
    created() {
      this.initPage()
    },
    methods: {
      show_url_method() {
        this.show_url = !this.show_url
      },
      show_review_method() {
        this.show_review = !this.show_review
      },
      re_generate_review() {
        const that = this
        this.$confirm('Are you sure you want to regenerate?', 'confirm', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'Cancel',
          type: 'warning',
          center: true
        }).then(() => {
          // that.generate_review()
          that.loading = true
          setTimeout(() => {
            that.loading = false
            if(that.now_number >= 4) {
              that.now_number = 0
            } else {
              that.now_number++
            }
            that.ai_generate_text = that.ai_content[that.now_number].reviews
          }, 2000);

        })
      },
      async copyToClipboard() {
        try {
          await navigator.clipboard.writeText(this.ai_generate_text);
          this.$message.success({message: "Copy Success"});
        } catch (err) {
          this.$message({
            message: 'Copy Error!',
            type: 'warning'
          });
        }
      },
      async generate_review() {
        let array = []
        for(let item of this.keywords) {
          if(item.is_select) {
            array.push(item.title)
          }
        }
        this.loading = true
        let param = {review_generator_uuid: this.obj.review_generator_uuid,comment: this.comment,keywords: array}
        let res = await postActionApi("/review/business-promoter/ai-generate", param)
        if(res.code == 200 || res.code == 201) {
            this.ai_content = res.data.slice(Math.max(0, res.data.length - 5))
            this.now_number = 0
            this.ai_generate_text = this.ai_content[this.now_number].reviews
          // this.ai_generate_text = res.data.join(",")
          // let param_result = {review_generator_uuid: this.obj.review_generator_uuid,keywords: array,
          // user_comment:this.comment,ai_generated_review:this.ai_generate_text,rating: true}
          // let res_result = await postActionApi("/review/business-promoter/ai-generate/results", param_result)
          this.show_url = true
          this.show_review = true
        }
        this.loading = false
      },
      select_keyword(item) {
        let number = 0;
        for(let item of this.keywords) {
          if(item.is_select) {
            number++
          }
        }
        if(number < 3) {
          if(!item.is_select) {
            item.is_select = true
          } else {
            item.is_select = false
          }
        } else {
          if(!item.is_select) {
            this.$message({
              message: 'Up to three keywords can be selected!',
              type: 'warning'
            });
          }
          if(item.is_select) {
            item.is_select = false
          }
        }
      },
      click_url(type, url) {
        let param = {review_generator_uuid: this.obj.review_generator_uuid}
        if(type == 1) {
          param.reviewed_google = true
        } else {
          param.reviewed_yelp = true
        }
        putActionApi("/review/business-promoter/ai-generate/post-updates", param).then(res => {
          if(res.code == 200 || res.code == 201) {
            window.location.href = url
          }
        })
      },
      submit_feedback() {
        if(this.feedback_text == "") {
          this.$message({
            message: 'Please leave your feedback information.',
            type: 'warning'
          });
          return;
        }
        let param = {
          bad_review_feedback: this.feedback_text,
          review_generator_uuid: this.obj.review_generator_uuid,
          rating:false
        }
        postActionApi("/review/business-promoter/ai-generate/results", param).then(res => {
          if(res.code == 200) {
            this.step = 4
          }
        })
      },
      async initPage() {
        this.key = this.$route.params.key
        try {
          this.loading_init = true
          this.step = 1
          let res = await getActionApi("/review/business-promoter/ai-generate/" + this.key)
          this.obj = res.data
          let array = []
          for(let item of res.data.customer_keywords) {
            let obj = {title: item, is_select: false}
            array.push(obj)
          }
          this.keywords = array
        } catch(e) {
          // the API answers 403 once the link is more than 7 days old
          if(e && e.response && e.response.status == 403) {
            this.step = 5
          } else {
            this.$router.push("/404");
          }
        }
        this.loading_init = false
      }
    }
  }
</script>
<style>
  .custom-rate .el-rate__icon{
    font-size: 30px;
  }
</style>
<style scoped>
  .content{background-color: #E9EEF5;min-height: 100vh;max-width: 500px;margin:auto;padding:20px;display: flex;align-items: inherit;}
  .item1{background-color: #ffffff;display: flex;flex-direction: column;align-items:center;padding:50px 0px;border-radius: 8px;width: 100%;}
  .item1 img{height: 55px;}
  .title{color: #5856D6;font-weight: bold;font-size: 18px;margin:10px 0;}
  p{text-align: center;line-height: 1.8;color:#2D3648;font-size: 14px;}
  .btnDiv{display: flex;justify-content: center;align-items: center;margin-top: 30px;}
  .btn{width: 60px;height: 35px;margin-right:20px;border-radius: 6px;display: flex;justify-content: center;align-items: center;border: 1px solid #5856D6;color: #5856D6;cursor: pointer;}
  .btnAct{padding:0 10px;height: 35px;border-radius: 6px;display: flex;justify-content: center;align-items: center;border: 1px solid #5856D6;color:#ffffff;background-color: #5856D6;cursor: pointer;}
  .textarea{width: 90%;}
  >>>.textarea textarea{height: 40vh;}
  .item2{background-color: #ffffff;display: flex;flex-direction: column;align-items:center;border-radius: 8px;width: 100%;justify-content: center;}
  .item3{background-color: #ffffff;display: flex;flex-direction: column;align-items:center;border-radius: 8px;width: 100%;padding:10px;}
  .item3 h1{font-size: 16px;width: 100%;padding:10px 0;justify-content: space-between;align-items: center;border-bottom:1px solid #DDDDDD;}
  .item3 .div{background-color: #F8F9FA;padding:20px;display: flex;flex-direction: column;align-items: center;margin-bottom:10px;width: 100%;}
  .item3 .div p{line-height: 1.5;}
  .item3 .div .lables{display: flex;flex-wrap: wrap;justify-content: center;margin:20px 0;}
  .item3 .div .lables span{border:1px solid #DDDDDD;color: #555555;height:24px;line-height:24px;border-radius: 12px;font-size: 14px;background-color: #ffffff;padding:0 10px;margin:0 4px 6px 0;cursor: pointer;}
  .item3 .div .lables .act{border-color: #5856D6;color: #5856D6;background-color: #eeeeff;}
  .menuItem{background-color: #ffffff;display: flex;padding:20px;width: 100%;margin-bottom: 20px;color: #2D3648;font-weight: bold;cursor: pointer;}
  .menuItem img{width: 24px;height: 24px;margin-right: 10px;}
  .menuItem:last-child{margin-bottom: 0;}
  >>>.div textarea{height: 90px;width: 100%;}
  @media (max-width: 768px) {

  }
  @media (min-width: 769px) {

  }
  .loading_div {position: fixed;z-index:99999;width: 100vw;height: 100vh;top: 0;left: 0;display:flex;align-items: center;justify-content: center;background-color: rgba(0, 0, 0, 0.7);flex-direction: column;}
</style>
